/* globals $ */
import intl from 'react-intl-universal'
import cleanPasteHTML from '../../util/cleanPasteHTML'

export default [
  'toastr',
  'contentApiService',
  'storyService',
  '$rootScope',
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  headlineController,
]

function headlineController(toastr, contentApi, storyService, $rootScope) {
  this.intl = intl

  this.$onInit = () => {
    if (this.storyObj.diffViewRevisionId) {
      this.headlines = this.storyObj[
        `rev${this.storyObj.diffViewRevisionId}`
      ].headlines
      this.subheadlines = this.storyObj[
        `rev${this.storyObj.diffViewRevisionId}`
      ].subheadlines
    } else {
      this.headlines = this.storyObj.headlines
      this.subheadlines = this.storyObj.subheadlines
    }
  }

  this.openHeadlines = false

  this.change = () => {
    storyService.setStoryProp('subheadlines', this.subheadlines)
    storyService.setStoryProp('headlines', this.headlines)
  }

  this.focusNextEnter = ($event, selector) => {
    if ($event.which === 13) {
      $event.preventDefault()
      if (selector) {
        $(selector).focus()
      }
      return false
    }
  }

  const replaceUnderscore = (str) => str.replace(/_/g, ' ')

  this.getHeadline = (headline) => {
    return intl
      .get(`HeadlineForm.form.${headline}`)
      .defaultMessage(replaceUnderscore(headline))
  }

  this.cleanWhitespace = (base, prop) => {
    if (base[prop] && base[prop].length) {
      base[prop] = base[prop]
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    }
    this.change()
  }

  this.cleanPaste = ($event) => {
    const clipboardData =
      $event.originalEvent.clipboardData || window.clipboardData
    const pastedDataHtml = clipboardData.getData('text/html')

    let pasteContent

    const txt = clipboardData.getData('text')
    console.group('x')
    console.log(txt.indexOf('\n'))
    console.groupEnd('x')

    if (txt.indexOf('\n') > -1) {
      const question = window.confirm(
        'We detected you have line breaks in your pasted content, ' +
          'did you really want to paste this content into the subheadline field?\n Click "Ok" to continue with paste.'
      )
      if (!question) {
        $event.preventDefault()
        return false
      }
    }

    if (pastedDataHtml) {
      const temp = $('<div></div>').html(pastedDataHtml)
      cleanPasteHTML(temp)
      // temp.find('h1,h2,h3,h4,h5,h6,p,div,nav,dl,dt,form,blockquote,ul,li,pre').each((i, el) => {
      temp
        .find('*')
        .not('b, u, i, em')
        .each((i, el) => {
          const jEl = $(el)
          if (jEl.html().length) {
            jEl.contents().unwrap()
          } else {
            jEl.remove()
          }
        })

      pasteContent = temp.html().trim()
    } else {
      pasteContent = clipboardData.getData('text')
    }

    document.execCommand('insertHTML', false, pasteContent)
    $event.preventDefault()
    this.change()
    return false
  }

  $rootScope.$on('BEFORE_SAVE', () => {
    Object.keys(this.headlines).forEach((headline) => {
      const currHeadline = this.headlines[headline]
      if (currHeadline && currHeadline.length) {
        this.headlines[headline] = currHeadline.replace(/<br\s*\/?>/g, '')
      }
    })
  })
}
